import { createRouter, createWebHashHistory } from 'vue-router'
import { i18n } from '@/i18n'
import { setupSeoMeta } from './meta'
import { setupRouterProgress } from './progress'
import { routes } from 'vue-router/auto-routes'

export const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    return savedPosition ?? { top: 0 }
  },
})

setupRouterProgress(router)

router.afterEach((to) => {
  // 已知路径显式翻译
  if (to.path === '/') {
    document.title = i18n.global.t('app.title')
    return
  }
  if (to.path === '/portfolio') {
    document.title = `${i18n.global.t('portfolio.title')} · Wei YAN`
    return
  }
  // 404
  if (to.name === 'not-found' || !to.matched.length) {
    document.title = i18n.global.t('app.notFoundTitle')
    return
  }
  // 其它路径：使用 meta.title（若有）
  const metaTitle = to.meta.title as string | undefined
  if (metaTitle) {
    document.title = metaTitle
  }
})

// 同步动态 SEO meta（canonical / og:url / og:title 等）
setupSeoMeta(router)
